import { Stack } from "@mui/material";
import { Locales } from "@simplyk/common";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardDialogValidation } from "@/dashboard-design-system/DialogValidation";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

type RemoveTranslationsDialogValidationProps = {
  removeTranslations: () => Promise<void>;
  removeTranslationsLoading: boolean;
  translationLocale: Locales;
  onRemoveSuccess?: () => void;
};

const RemoveTranslationsDialogValidation = ({
  removeTranslations,
  removeTranslationsLoading,
  onRemoveSuccess,
}: RemoveTranslationsDialogValidationProps) => {
  const { t } = useTranslate();

  return (
    <DashboardDialogValidation
      vibe="danger"
      maxWidth="xs"
      fullWidth
      title={t("dashboard", "donation.forms.list.deleteModal.title")}
      content={
        <Stack>
          <DashboardTypography variant="subtitle2" vibe="neutralVariant-20">
            {t("dashboard", "form.removeTranslationsDialogValidation.body")}
          </DashboardTypography>
        </Stack>
      }
      actions={{
        main: {
          onClick: () => {
            removeTranslations().then(() => {
              onRemoveSuccess?.();
            });
          },
        },
      }}
      hideIcon
    >
      <DashboardButton variant="outlined" vibe="warning" isLoading={removeTranslationsLoading}>
        {t("dashboard", "form.removeTranslationsDialogValidation.button")}
      </DashboardButton>
    </DashboardDialogValidation>
  );
};

export default RemoveTranslationsDialogValidation;
